import { Button, Divider, Form, Input, message, Modal, Select } from "antd";
import { useEffect, useMemo, useState } from "react";
import DeleteIcon from "../../../../components/icons/DeleteIcon";
import { isValidURL } from "../../../../common/helpers";
import { AddBrandProduct, addRequestForBrandDoc, UpdateBrandProduct, updateRequestForBrandDoc } from "../../../../API/endpoints/Brands";
import { addRequestForProductDoc, updateRequestForProductDoc } from "../../../../API/endpoints/Products";
import { validateAlphaNumericWithSpecialCharsAndLetters } from "../../../../common/validators";

interface Props {
    open: boolean;
    editData?: any;
    onCancel: () => void;
    onSuccess: (data: any) => void;
    brand: any,
    isProduct: boolean;
    products: any[]
}
const AddEditProductAssetModal = (props: Props) => {
    const { editData, open, onSuccess, brand, isProduct, products } = props;
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const [submitLoading, setSubmitLoading] = useState(false);



    useEffect(() => {
        if (editData && Object.keys(editData).length > 0) {
            form.setFieldsValue({
                product: editData?.product_id,
                fileName: editData?.file_name,
                description: editData?.description
            })
        }
    }, [editData])

    const onSubmit = () => {
        form.validateFields().then((values: any) => {
            setSubmitLoading(true);
            if (isProduct) {
                const req = {
                    product_id: values?.product,
                    file_name: values?.fileName,
                    description: values?.description,
                }
                if (editData && Object.keys(editData).length > 0) {
                    updateRequestForProductDoc(editData?.id, req).then((res: any) => {
                        onSuccess(res?.data)
                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                } else {
                    addRequestForProductDoc(req).then((res: any) => {
                        onSuccess(res?.data)
                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                }
            } else {
                const req = {
                    brand_id: brand.id,
                    file_name: values?.fileName,
                    description: values?.description,
                }
                if (editData && Object.keys(editData).length > 0) {
                    updateRequestForBrandDoc(editData?.id, req).then((res: any) => {
                        onSuccess(res?.data)
                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                } else {
                    addRequestForBrandDoc(req).then((res: any) => {
                        onSuccess(res?.data)
                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                }
            }
        })
    }

    const onCancel = () => {
        props?.onCancel();
        onReset()
    }

    const onReset = () => {
        form.resetFields();

    }


    return (
        <Modal
            width={500}
            open={open}
            onCancel={() => onCancel()}
            classNames={{
                content: "!p-0 h-[calc(100vh-40px)] flex flex-col",
                header: "!px-[20px] !pt-[16px] !pb-[10px] !my-0 bg-white",
                body: "!px-[20px] !py-[12px] bg-[#F9FAFB] flex-1 overflow-auto",
                footer: "!px-[20px] !py-[12px] !mt-0",

            }}
            className="h-[calc(100% - 40px)] top-[20px] right-[20px] absolute pb-0"
            title={(
                <p className="m-0 font-[500] text-[14px]">
                    {editData && Object.keys(editData).length > 0 ? "Edit Doc Requests" : "New Doc Requests"}
                </p>
            )}
            okText={editData && Object.keys(editData).length > 0 ? "Save" : "Request"}
            cancelButtonProps={{
                type: 'text',
                className: "text-[#667085]"
            }}
            okButtonProps={{
                loading: submitLoading
            }}
            onOk={() => onSubmit()}
        >
            <Form layout="vertical" requiredMark={false} form={form}>
                {contextHolder}
                <div className="grid grid-cols-1 gap-[16px]">
                    {isProduct ? (
                        <Form.Item
                            name="product"
                            label="Product"
                            rules={[{ required: true }]}
                        >

                            <Select
                                placeholder="Select product"
                                options={products}
                                fieldNames={{ label: "name", value: "id" }}
                            />
                        </Form.Item>
                    ) : (
                        <></>
                    )}

                    <Form.Item
                        name="fileName"
                        label="Document / File Name"
                        rules={[validateAlphaNumericWithSpecialCharsAndLetters]}
                    >
                        <Input
                            type="text"
                            placeholder="Document / File Name"
                        />
                    </Form.Item>
                    <Form.Item
                        name="description"
                        label="Description"
                        rules={[validateAlphaNumericWithSpecialCharsAndLetters]}
                    >
                        <Input.TextArea
                            placeholder="Description"
                        />
                    </Form.Item>
                </div>
            </Form>

        </Modal>
    )
}

export default AddEditProductAssetModal